import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @file 密码强度检测器
 */
import { createEnumHelper, PasswordStrengthEnum, getPasswordStrength, } from '@seiue/util';
import { useMemo } from 'react';
import styled from 'styled-components';
import { useTranslation } from '../i18n';
export const PasswordStrength = ({ password }) => {
    const { t } = useTranslation();
    const passwordStrengthEnumLabelHelper = useMemo(() => createEnumHelper(() => ({
        [PasswordStrengthEnum.Weak]: t('较弱'),
        [PasswordStrengthEnum.Normal]: t('适中'),
        [PasswordStrengthEnum.Strong]: t('较强'),
    })), [t]);
    const strength = getPasswordStrength(password);
    return (_jsxs(Wrapper, { children: [_jsxs(Left, { children: [_jsx(LeftItem1, { type: strength }, void 0), _jsx(LeftItem2, { type: strength }, void 0), _jsx(LeftItem3, { type: strength }, void 0)] }, void 0), _jsx(Desc, Object.assign({ type: strength }, { children: t('密码强度{{type}}', {
                    type: strength ? passwordStrengthEnumLabelHelper.get(strength) : '',
                }) }), void 0)] }, void 0));
};
const Wrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 5px;
`;
const Left = styled.div `
  display: flex;
  flex: auto;
  align-items: center;
  justify-content: flex-start;
`;
const LeftItem = styled.div `
  flex: 1;
  height: 8px;
  margin-right: 8px;
  border-radius: 4px;
  max-width: 28px;
  min-width: 28px;
`;
const LeftItem1 = styled(LeftItem) `
  background-color: ${props => {
    if (!props.type)
        return '#F3F4F8';
    if (props.type === PasswordStrengthEnum.Weak)
        return '#F7585B';
    if (props.type === PasswordStrengthEnum.Normal)
        return '#FCA700';
    return '#16C89E';
}};
`;
const LeftItem2 = styled(LeftItem) `
  background-color: ${props => {
    if (props.type === PasswordStrengthEnum.Strong)
        return '#16C89E';
    if (props.type === PasswordStrengthEnum.Normal)
        return '#FCA700';
    return '#F3F4F8';
}};
`;
const LeftItem3 = styled(LeftItem) `
  flex: 1;
  height: 8px;
  margin-right: 10px;
  background-color: ${props => {
    if (props.type === PasswordStrengthEnum.Strong)
        return '#16C89E';
    return '#F3F4F8';
}};
  border-radius: 4px;
`;
const Desc = styled.span `
  color: ${p => p.theme.text._2};
  font-size: 13px;
  visibility: ${props => (!props.type ? 'hidden' : 'visible')};
`;
//# sourceMappingURL=data:application/json;base64,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